import { render, staticRenderFns } from "./DemandDetails.vue?vue&type=template&id=d4b9418c&scoped=true"
import script from "./DemandDetails.vue?vue&type=script&lang=js"
export * from "./DemandDetails.vue?vue&type=script&lang=js"
import style0 from "./DemandDetails.vue?vue&type=style&index=0&id=d4b9418c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b9418c",
  null
  
)

export default component.exports